import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { PUT } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { UPDATE_PROMOTION, UPDATE_PROMOTION_FAI, UPDATE_PROMOTION_SUCCESS } from '../redux/Promotions';
import { SET_MODAL } from '../redux/Modal';

function* UpdatePromotionFlow({ payload: { promotionId, values, }, }) {
  try {
    const params = { promotion: values, };
    const endpoint = `${apiRoot}/promotions/${promotionId}`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: PUT, endpoint, params, });
    yield put(UPDATE_PROMOTION_SUCCESS(response));
  } catch (error) {
    yield put(UPDATE_PROMOTION_FAI(error));
  } finally {
    yield put(SET_MODAL({ componentName: 'UpdatePromotionModal', isCloseButtonShown: false, }));
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* UpdatePromotion() {
  yield takeLatest(UPDATE_PROMOTION, UpdatePromotionFlow);
}
